export enum LUMX_INPUTS {
    /**
     * @value Selected %SELECT_LABEL%
     * @description The title of the chip group of a Multiple Select, it will only be read by screen readers and will never be displayed.
     * It takes a SELECT_LABEL variable, that will be the label of the select.
     * The select label should be descriptive of the type of items we are picking, so it can be used to described the type of selected items.
     * Default value for this variable will be "values" (in english)
     */
    SELECTED_VALUES_LIST_LABEL = 'COMBOBOX.SELECTED_VALUES_LIST_LABEL',
    /**
     * @value This URL is invalid.
     * @description In mobile navigation admin page, the error message displayed when the user type an invalid url in the URL input
     */
    URL_FIELD_ERROR_MESSAGE = 'ADMIN.MOBILE.NAVIGATION.EXTERNAL_LINK.URL_FIELD.ERROR_MESSAGE',
    /**
     * @value URL
     * @description In Mobile navigation admin page, the label of the URL input.
     */
    URL_FIELD_LABEL = 'ADMIN.MOBILE.NAVIGATION.EXTERNAL_LINK.URL_FIELD.LABEL',
}
